import { LoaderScreen } from '@/components/Elements';
import { useSetPageOffsetAtom } from '@/features/analyze/atoms/pageCondition.atom';
import { AnalyzeLayout } from '@/features/analyze/components/AnalyzeLayout';
import { Pagination } from '@/features/analyze/components/Pagination';
import { PerPageSelect } from '@/features/analyze/components/PerPageSelect';
import { ResultNotFond } from '@/features/analyze/components/ResultNotFond';
import { SearchResult } from '@/features/analyze/components/SearchResult';
import { useAnalyzeSearch } from '@/features/analyze/hooks/useAnalyzeSearch';
import { maskFragments } from '@/lib/graphql';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

export const Search = () => {
  const analyzeHeaderRef = useRef<HTMLDivElement>(null);
  const { docs, pageInfo, isLoading } = useAnalyzeSearch();
  const setPageOffset = useSetPageOffsetAtom();
  const { t } = useTranslation();

  const fragment = SearchResult.fragments.data;
  const fragmentDocs = docs ? maskFragments([fragment], docs) : [];

  if (isLoading) {
    return (
      <AnalyzeLayout>
        <LoaderScreen />
      </AnalyzeLayout>
    );
  }

  if (!docs?.length) {
    return (
      <AnalyzeLayout>
        <ResultNotFond />
      </AnalyzeLayout>
    );
  }

  const handlePageClick = (pageStart: number) => {
    setTimeout(() => {
      analyzeHeaderRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }, 100);

    setPageOffset(pageStart);
  };

  return (
    <AnalyzeLayout analyzeHeaderRef={analyzeHeaderRef}>
      <div className="flex w-full flex-col items-center px-5 xl:px-36">
        <div className="mt-3 flex w-full items-center justify-between text-xs text-zinc-700 lg:mt-2">
          {t('約 {{articleCount}} 件', {
            articleCount: pageInfo?.totalCount.toLocaleString() ?? 0,
          })}

          <div className="flex items-center">
            {t('表示件数')}:
            <PerPageSelect />
          </div>
        </div>

        <div className="mt-5 flex w-11/12 flex-col items-center">
          <SearchResult docs={fragmentDocs} />

          {pageInfo && (
            <Pagination
              pageInfo={pageInfo}
              className="mb-16 mt-8"
              onClick={handlePageClick}
            />
          )}
        </div>
      </div>
    </AnalyzeLayout>
  );
};
